import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { SettingsService } from '@app/_services/settings.service';

/**
 * A circular public indicator that matches the style of FavoriteIndicatorComponent.
 * Shows a globe icon in a circular container with border.
 * Used to indicate public items (notes, lists, etc.) in list views.
 *
 * Matches Flutter's MePublicIndicator implementation.
 */
@Component({
  selector: 'app-public-indicator',
  standalone: true,
  imports: [CommonModule, SvgComponent],
  template: `
        <app-svg
          name="commonGlobeBlock"
          [color]="ss.theme().color12">
        </app-svg>
  `,
  styles: []
})
export class PublicIndicatorComponent {
  @Input() radius = 9;
  @Input() addBorder = true;

  ss = inject(SettingsService);

  get diameter(): number {
    return this.radius * 2;
  }

  get iconSize(): number {
    return this.diameter * 0.77;
  }

  get iconSizeStr(): string {
    return this.iconSize + 'px';
  }
}
